import styled from 'styled-components';

export const Legend = styled.div`
  background: white;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  position: absolute;
  right: 8px;
  bottom: 8px;
  padding: 8px;

  h3,
  p {
    font-size: 10px;
  }
`;
